import { degrees } from './degrees';

export const pathway = [
    {
        key: '1',
        name: 'What brings you to the Faculty of Education?',
        options: [
            {
                name: 'I want to become a K-12 teacher',
                value: '1.2.0',
            },
            {
                name: 'I want to explore how the field of education can support my interests',
                value: '1.3.0',
            },
            {
                name: 'I want to become a counsellor',
                results: true,
                value: '1.4.0',
            },
            {
                name: 'I want to build on my extensive professional experience in an educational or professional setting',
                value: '1.5.0',
            }
        ]
    },

    // top level
    {
        key: '1.2.0',
        name: 'Are you interested in teaching at the elementary or secondary level?',
        options: [
            {
                name: 'Elementary',
                value: '1.2.1',
            },
            {
                name: 'Secondary',
                value: '1.2.2',
            },
        ]
    },
    {
        key: '1.2.1',
        name: 'Are you looking to learn / study in French?',
        options: [
            {
                name: 'Yes',
                results: true,
                value: '1.2.1.1',
            },
            {
                name: 'No',
                results: true,
                value: '1.2.1.2',
            },
        ]
    },
    {
        key: '1.2.2',
        name: 'Are you looking to learn / study in French?',
        options: [
            {
                name: 'Yes',
                results: true,
                value: '1.2.2.1',
            },
            {
                name: 'No',
                results: true,
                value: '1.2.2.2',
            },
        ]
    },

    // top level
    {
        key: '1.3.0',
        name: 'Are you looking to learn / study in French?',
        options: [
            {
                name: 'Yes',
                results: true,
                value: '1.3.0.2.1',
            },
            {
                name: 'No',
                results: true,
                value: '1.3.0.2.2',
            },
        ]
    },


    // top level
    // goes directly to results
    {
        key: '1.4.0',
        options: [],
        // skipToResults: '1.4.1',
    },

    // top level
    {
        key: '1.5.0',
        name: 'What credential are you interested in?',
        options: [
            {
                name: 'Undergraduate Degree',
                value: '1.5.1',
            },
            {
                name: 'Master’s Degree',
                value: '1.5.2',
            },
        ]
    },
    {
        key: '1.5.1',
        name: 'Are you looking to learn / study in French?',
        options: [
            {
                name: 'Yes',
                results: true,
                value: '1.5.1.1',
            },
            {
                name: 'No',
                results: true,
                value: '1.5.1.2',
            },
        ]
    },
    {
        key: '1.5.2',
        name: 'What areas of study are you interested in ?',
        type: 'checkbox',
        maxSelection: 3,
        options: [
            ...degrees.graduateStudies
        ]
    },
];

export const results = [
    {
        id: '1.2.1.1', // french yes
        primary: {
            links: [
                {
                    title: 'Preparation for Teacher Education in French',
                    subtitle: 'Pathways to teaching French in BC',
                    url: 'https://www.sfu.ca/baff-offa/en/programs/undergraduate/educ/teacher-preparation.html'
                },
                {
                    title: 'Bachelor of General Studies in Education (BGS)',
                    subtitle: 'Explore a wide variety of subjects',
                    url: 'https://www.sfu.ca/education/programs/undergraduate-studies/bachelor-of-general-studies/about.html'
                },
                {
                    title: 'Undergraduate Courses in Education',
                    subtitle: 'Explore educational theories and research',
                    url: 'https://www.sfu.ca/education/programs/undergraduate-studies/courses.html'
                }
            ],
        },
        secondary: {
            links: [
                {
                    title: 'Professional Development Program (PDP) | French Module',
                    url: 'https://www.sfu.ca/education/programs/teacher-ed/programmes-en-francais.html '
                },
                {
                    title: 'Post Baccalaureate Diploma in French and Education',
                    url: 'http://www.sfu.ca/students/calendar/2022/spring/programs/french-and-education/post-baccalaureate-diploma.html'
                },
                {
                    title: 'Bachelor of Education (BEd) as a second degree',
                    url: 'https://www.sfu.ca/education/programs/undergraduate-studies/bachelor-of-education/about.html'
                },
            ]
        }
    },
    {
        id: '1.2.1.2', // french no
        primary: {
            links: [
                {
                    title: 'Bachelor of General Studies in Education (BGS)',
                    subtitle: 'Explore a wide variety of subjects',
                    url: 'https://www.sfu.ca/education/programs/undergraduate-studies/bachelor-of-general-studies/about.html'
                },
                {
                    title: 'Undergraduate Courses in Education',
                    subtitle: 'Explore educational theories and research',
                    url: 'https://www.sfu.ca/education/programs/undergraduate-studies/courses.html'
                }
            ]
        },
        secondary: {
            links: [
                {
                    title: 'Professional Development Program (PDP)',
                    url: 'https://www.sfu.ca/education/programs/teacher-ed/pdp/about.html'
                },
            ]
        }
    },
    {
        id: '1.2.2.1', // french yes
        primary: {
            links: [
                {
                    title: 'Preparation for Teacher Education in French',
                    subtitle: 'Pathways to teaching French in BC',
                    url: 'https://www.sfu.ca/baff-offa/en/programs/undergraduate/educ/teacher-preparation.html'
                },
                {
                    title: 'Education Minor',
                    subtitle: 'Complement your chosen area of study',
                    url: 'https://www.sfu.ca/education/programs/undergraduate-studies/minors.html'
                },
                {
                    title: 'Undergraduate Education Courses in French',
                    subtitle: 'Explore educational theories and research',
                    url: 'https://www.sfu.ca/baff-offa/en/programs/undergraduate/educ/courses-educ.html'
                }
            ]
        },
        secondary: {
            links: [
                {
                    title: 'Professional Development Program (PDP) | French Module',
                    url: 'https://www.sfu.ca/education/programs/teacher-ed/programmes-en-francais.html'
                },
                {
                    title: 'Post Baccalaureate Diploma in French and Education',
                    url: 'http://www.sfu.ca/students/calendar/2022/spring/programs/french-and-education/post-baccalaureate-diploma.html'
                },
                {
                    title: 'Bachelor of Education (BEd) as a second degree',
                    url: 'https://www.sfu.ca/education/programs/undergraduate-studies/bachelor-of-education-as-a-second-degree/about.html'
                },
            ]
        }
    },
    {
        id: '1.2.2.2', // french no
        primary: {
            links: [
                {
                    title: 'Education Minor',
                    subtitle: 'Complement your chosen area of study',
                    url: 'https://www.sfu.ca/education/programs/undergraduate-studies/minors.html'
                },
                {
                    title: 'Undergraduate Courses in Education ',
                    subtitle: 'Explore educational theories and research',
                    url: 'https://www.sfu.ca/education/programs/undergraduate-studies/courses.html'
                },
                {
                    title: 'Bachelor of General Studies in Education (BGS)',
                    subtitle: 'Two teachable minors and an Education minor in the BGS',
                    url: 'https://www.sfu.ca/education/programs/undergraduate-studies/bachelor-of-general-studies/about.html'
                }
            ]
        },
        secondary: {
            links: [
                {
                    title: 'Professional Development Program (PDP)',
                    subtitle: 'SFU’s teacher education program',
                    url: 'https://www.sfu.ca/education/programs/teacher-ed/pdp/about.html'
                },
            ]
        },
    },
    {
        id: '1.3.0.2.1', // fr yes
        primary: {
            links: [
                {
                    title: 'Undergraduate Education Courses in French',
                    subtitle: 'Explore education studies en francais',
                    url: 'https://www.sfu.ca/baff-offa/en/programs/undergraduate/educ/courses-educ.html',
                },
                {
                    title: 'Bachelor of General Studies in Education (BGS)',
                    subtitle: 'Explore a wide variety of subjects',
                    url: ' https://www.sfu.ca/education/programs/undergraduate-studies/bachelor-of-general-studies/about.html'
                },
                {
                    title: 'Education Minor',
                    subtitle: 'Complement your chosen area of study',
                    url: 'https://www.sfu.ca/education/programs/undergraduate-studies/minors.html'
                }
            ]
        },
        secondary: {
            links: [
                {
                    title: 'Programmes en langue francaise',
                    url: 'https://www.sfu.ca/education/gs/futurestudents/areas-of-study/programsinfrench.html',
                },
                {
                    title: 'Post Baccalaureate Diploma in French and Education',
                    url: ' https://www.sfu.ca/education/programs/professional-studies/post-bacc/fr-edu-pbd.html'
                },
                {
                    title: 'Master’s Degree Programs',
                    url: 'https://www.sfu.ca/education/programs/graduate-studies.html'
                }
            ]
        }
    },
    {
        id: '1.3.0.2.2', // fr no
        primary: {
            links: [
                {
                    title: 'Bachelor of General Studies in Education (BGS)',
                    subtitle: 'Explore a wide variety of subjects',
                    url: 'https://www.sfu.ca/education/programs/undergraduate-studies/bachelor-of-general-studies/about.html'
                },
                {
                    title: 'Education Minor',
                    subtitle: 'Complement your chosen area of study',
                    url: 'https://www.sfu.ca/education/programs/undergraduate-studies/minors.html'
                },
                {
                    title: 'Undergraduate Courses in Education',
                    subtitle: 'Explore educational theories and research',
                    url: 'https://www.sfu.ca/education/programs/undergraduate-studies/courses.html'
                }
            ]
        },
        secondary: {
            links: [

                {
                    title: 'Post Baccalaureate Diplomas (PBD)',
                    url: 'https://www.sfu.ca/education/programs/professional-studies/post-bacc.html'
                },
                {
                    title: 'Master’s Degree Programs',
                    url: 'https://www.sfu.ca/education/programs/graduate-studies.html'
                }
            ]
        }
    },
    {
        id: '1.4.0',
        primary: {
            links: [
                {
                    title: 'Counselling and Human Development Minor',
                    subtitle: 'A foundation in counselling theory and practice',
                    url: ' https://www.sfu.ca/education/programs/undergraduate-studies/minors/counselling-human-development-minor.html'
                }
            ]
        },
        secondary: {
            links: [
                {
                    title: 'Post Baccalaureate Diploma in Counselling and Human Development',
                    url: 'https://www.sfu.ca/education/programs/professional-studies/post-bacc/counselling-human-development-pbd.html'
                },
                {
                    title: 'Counselling Psychology MA, MEd',
                    url: 'https://www.sfu.ca/education/gs/degreediploma/masters/counspsych.html'
                }
            ]
        }
    },
    {
        id: '1.5.1.1',
        primary: {
            links: [
                {
                    title: 'Undergraduate Education Courses in French',
                    subtitle: 'Explore education studies en francais',
                    url: 'https://www.sfu.ca/baff-offa/en/programs/undergraduate/educ/courses-educ.html',
                },
                {
                    title: 'Bachelor of General Studies in Education (BGS)',
                    subtitle: 'Explore a wide variety of subjects',
                    url: 'https://www.sfu.ca/education/programs/undergraduate-studies/bachelor-of-general-studies/about.html'
                },
                {
                    title: 'Education Minor',
                    subtitle: 'Complement your chosen area of study',
                }
            ]
        },
        secondary: {
            links: [
                {
                    title: 'Programmes en langue francaise',
                    url: 'https://www.sfu.ca/education/gs/futurestudents/areas-of-study/programsinfrench.html',
                },
                {
                    title: 'Post Baccalaureate Diploma in French and Education',
                    url: 'https://www.sfu.ca/education/programs/professional-studies/post-bacc/fr-edu-pbd.html'
                },
                {
                    title: 'Master’s Degree Programs',
                    url: 'https://www.sfu.ca/education/programs/undergraduate-studies/minors.html'
                }
            ]
        }
    },
    {
        id: '1.5.1.2', // fr no
        primary: {
            links: [
                {
                    title: 'Bachelor of General Studies in Education (BGS)',
                    subtitle: 'Explore a wide variety of subjects',
                    url: 'https://www.sfu.ca/education/programs/undergraduate-studies/bachelor-of-general-studies/about.html'
                },
                {
                    title: 'Education Minor',
                    subtitle: 'Complement your chosen area of study',
                    url: 'https://www.sfu.ca/education/programs/undergraduate-studies/minors.html'
                },
                {
                    title: 'Undergraduate Courses in Education',
                    subtitle: 'Explore educational theories and research',
                    url: 'https://www.sfu.ca/education/programs/undergraduate-studies/courses.html'
                }
            ]
        },
        secondary: {
            links: [
                {
                    title: 'Post Baccalaureate Diplomas (PBD)',
                    url: 'https://www.sfu.ca/education/programs/teacher-ed/pdp/about.html'
                },
                {
                    title: 'Master’s Degree Programs',
                    url: 'https://www.sfu.ca/education/programs/graduate-studies.html'
                }
            ]
        }
    },
    {
        id: '1.5.2',
        primary: {
            links: [
                ...degrees.graduateStudies
            ]
        },
        secondary: {
            links: [
               {
                   title: 'Doctoral Degree Programs'
               }
            ]
        },
        footnote: {
            prerequisite: true,
            text: 'Extensive professional experience in an educational or professional setting required for non-degree applicants. Review the program admission requirements or contact the Graduate Studies office to learn more.'
        }
    }
]

// export default pathway1;
